import { render, staticRenderFns } from "./shift-table-status-staff.vue?vue&type=template&id=23584946"
import script from "./shift-table-status-staff.vue?vue&type=script&lang=js"
export * from "./shift-table-status-staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports